import React, { useState } from 'react';
import { esCorreoValido } from '../../utils/emailValidation';

export interface ModalCorreoContentProps {
  correoInicial?: string;
  onConfirmar: (correo: string) => Promise<void> | void;
  procesando?: boolean;
}

export const ModalCorreoContent: React.FC<ModalCorreoContentProps> = ({
  correoInicial = '',
  onConfirmar,
  procesando = false
}) => {
  const [correo, setCorreo] = useState(correoInicial);
  const [errorValidacion, setErrorValidacion] = useState<string | null>(null);

  const handleConfirmar = async () => {
    const correoLimpio = correo.trim();
    if (!correoLimpio) {
      setErrorValidacion('Por favor ingrese un correo electrónico.');
      return;
    }

    if (!esCorreoValido(correoLimpio)) {
      setErrorValidacion('El formato del correo electrónico no es válido (ejemplo: usuario@dominio.com).');
      return;
    }

    setErrorValidacion(null);
    await onConfirmar(correoLimpio);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCorreo(e.target.value);
    if (errorValidacion) {
      setErrorValidacion(null);
    }
  };

  return (
    <div
      style={{
        padding: '30px 25px 25px',
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        position: 'relative',
        boxSizing: 'border-box'
      }}
    >
      {/* Ícono de alerta naranja */}
      <div
        style={{
          width: '55px',
          height: '55px',
          backgroundColor: '#f59e0b',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '16px',
          boxShadow: '0 4px 12px rgba(245, 158, 11, 0.25)'
        }}
      >
        <span
          style={{
            color: '#ffffff',
            fontSize: '32px',
            fontWeight: '700',
            lineHeight: '1'
          }}
        >
          !
        </span>
      </div>

      {/* Título */}
      <h3
        style={{
          margin: '0 0 10px 0',
          fontSize: '18px',
          fontWeight: '700',
          color: '#1e293b',
          lineHeight: '1.3'
        }}
      >
        Confirmación de Correo Notificación
      </h3>

      {/* Texto descriptivo */}
      <p
        style={{
          margin: '0 0 18px 0',
          fontSize: '14px',
          color: '#64748b',
          lineHeight: '1.5',
          maxWidth: '420px'
        }}
      >
        No encontramos un correo registrado o válido en su sesión activa.<br />
        Por favor ingrese el correo electrónico donde desea recibir el comprobante de la gestión realizada:
      </p>

      {/* Input de correo */}
      <input
        type="email"
        placeholder="ejemplo@correo.com"
        value={correo}
        onChange={handleChange}
        disabled={procesando}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            handleConfirmar();
          }
        }}
        style={{
          width: '100%',
          maxWidth: '400px',
          padding: '10px 14px',
          marginBottom: errorValidacion ? '6px' : '10px',
          borderRadius: '6px',
          border: errorValidacion ? '1px solid #ef4444' : '1px solid #cbd5e1',
          backgroundColor: '#f8fafc',
          boxSizing: 'border-box',
          fontSize: '14px',
          color: '#1e293b',
          outline: 'none',
          textAlign: 'left'
        }}
      />

      {/* Mensaje de error de validación */}
      {errorValidacion && (
        <p
          style={{
            margin: '0 0 10px 0',
            fontSize: '13px',
            color: '#ef4444',
            textAlign: 'left',
            width: '100%',
            maxWidth: '400px'
          }}
        >
          {errorValidacion}
        </p>
      )}

      {/* Nota informativa */}
      <p
        style={{
          margin: '0 0 20px 0',
          fontSize: '12px',
          color: '#64748b',
          fontStyle: 'italic'
        }}
      >
        * Este correo se usará únicamente para el envío de esta transacción.
      </p>

      {/* Botón principal */}
      <button
        onClick={handleConfirmar}
        disabled={procesando}
        style={{
          backgroundColor: procesando ? '#94a3b8' : '#2563eb',
          color: '#ffffff',
          border: 'none',
          borderRadius: '6px',
          padding: '10px 32px',
          fontSize: '15px',
          fontWeight: '600',
          cursor: procesando ? 'not-allowed' : 'pointer',
          boxShadow: '0 4px 12px rgba(37, 99, 235, 0.25)',
          transition: 'background-color 0.2s ease',
          width: 'auto',
          minWidth: '200px'
        }}
      >
        {procesando ? 'Procesando...' : 'Confirmar y Enviar'}
      </button>
    </div>
  );
};

export default ModalCorreoContent;
